import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-intro-home',
  templateUrl: './intro-home.component.html',
  styleUrls: ['./intro-home.component.css']
})
export class IntroHomeComponent implements OnInit {

  src_pdf : string;

  constructor(private router: Router) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".intro-intro").addClass("header_active")
    if (window.location.href.indexOf("/fr/") > -1)
      this.src_pdf="../../assets/SDG-PSS-guidelines-2019-FR.pdf";
    else if (window.location.href.indexOf("/es/") > -1)
      this.src_pdf="../../assets/SDG-PSS-guidelines-2019-V3.pdf";
    else
      this.src_pdf="../../assets/SDG-PSS-guidelines-2019-V3.pdf";  
  }
}



// WEBPACK FOOTER //
// ./src/app/introduction/intro-home/intro-home.component.ts